import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {buildChannelSettingsPath} from '../../../../helpers/models/channelHelpers';
import {AppState} from '../../../../store/appState';
import {ThunkAction} from '../../../../store/appThunk';
import {makeGetChannel, makeGetChannelInbox} from '../../../../store/data/channels/channelsSelectors';
import {getCompany} from '../../../../store/data/company/companySelectors';
import {getHasNewInboxSettingsDetails} from '../../../../store/featureFlags/featureFlagsSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {MeetingRoomsDropdownBox} from './meetingRoomsDropdownBox';

/*
 * Props.
 */

interface MeetingRoomsDropdownBoxContainerProps {
  channelId: number;
}

/*
 * Selectors.
 */

function getChannelId(_state: AppState, props: MeetingRoomsDropdownBoxContainerProps) {
  return props.channelId;
}

function makeGetRequiredChannel() {
  const getChannel = makeGetChannel(getChannelId);
  return createSelector([getChannel], (channel) => {
    if (!channel) {
      throw new Error('A channel with the specified ID could not be found.');
    }

    return channel;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MeetingRoomsDropdownBoxContainerProps>()(() => ({
  channel: makeGetRequiredChannel(),
  company: getCompany,
}));

const mapDispatchToProps = makeMapDispatchToProps<MeetingRoomsDropdownBoxContainerProps>()((props) => ({
  onGoToReAuthChannelSettingsClick: (): ThunkAction => (dispatch, getState) => {
    const state = getState();
    const getChannel = makeGetRequiredChannel();
    const getInbox = makeGetChannelInbox(getChannel);

    const channel = getChannel(state, props);
    const inbox = getInbox(state, props);

    if (!inbox) {
      throw new Error('An inbox with the specified ID could not be found.');
    }

    const settingsPath = buildChannelSettingsPath(getHasNewInboxSettingsDetails(state), inbox, channel);
    dispatch(navigateToLinkAction(settingsPath));
  },
}));

export const MeetingRoomsDropdownBoxContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MeetingRoomsDropdownBox);
